import React, { Fragment } from "react";
import { Link } from "react-scroll";

const doctorDeptListNagaraBhavi = [
  {
    id: 1,
    deptTitle: "Obstetrics and Gynaecology",
    dept: "obstetrics_and_gynecology",
  },
  {
    id: 2,
    dept: "paediatrics_and_subspeciatilies",
    deptTitle: "Paediatrics and SubSpecialities",
  },
  {
    id: 12,
    deptTitle: "Other Specialities",
    dept: "other_specialities",
  },
];
const DeptList = ({ onSetActiveFunc }) => {
  const [deptList, setDeptList] = React.useState(doctorDeptListNagaraBhavi);

  return (
    <Fragment>
      <br />
      <div className="container">
        <div className="row deptListDiv">
          {deptList.map((deptData) => (
            <div key={deptData.id} className="col-sm-4 cardComp">
              <Link
                activeclassname="active"
                to={deptData.dept}
                spy={true}
                smooth={true}
                duration={1000}
                delay={500}
                offset={-300}
                onSetActive={onSetActiveFunc}
              >
                <div className="card cardStyle">
                  <div className="card-body">
                    <h5 className="card-title cardTitle">
                      {deptData.deptTitle}
                    </h5>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <br />
    </Fragment>
  );
};

// export default DeptList;
export { doctorDeptListNagaraBhavi };
